import { FunctionalComponent, h } from "@stencil/core";

interface TableCellProps {
    group?: boolean;
    empty?: boolean;
    sort?: string;
    multiline?: boolean;
    testId?: string;
}

const tableClass = "uic-table";
export const TableCell: FunctionalComponent<TableCellProps> = (
    { group = false, empty = false, sort = null, multiline = false, testId = null },
    children
) => {
    const testIdValue = testId == null ? null : `${tableClass}__td-${testId}`;

    return (
        <td
            class={{
                [`${tableClass}__td`]: true,
                [`${tableClass}__td--multiline`]: multiline
            }}
            data-sort={sort}
            data-testid={testIdValue}
        >
            <div
                class={{
                    [`${tableClass}__cell-container`]: true,
                    [`${tableClass}__cell-container--no-data`]: empty,
                    [`${tableClass}__cell-container--group`]: group
                }}
            >
                {children}
            </div>
        </td>
    );
};
